/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import {useState, useEffect} from 'react';

// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";

// Overview page components
import Header from "layouts/retailerProfile/components/Header";

import {getMyCompany} from "api/company/getMyCompany"
import { useTokenContext } from 'App';

import {getPhotoSource} from "api/requests"
import {readStream} from "readStream/readStream"

function RetailerProfile() {

  const {token} = useTokenContext();
  const [company, setCompany] = useState(null);
  const [myStorage, setMyStorage] = useState([])
  const [nrPhotosDownloaded, setNrPhotosDownloaded] = useState(0)

  const doGetMyCompany = async () => {
    try {
      let companyPromise = await getMyCompany(token);
      setCompany(companyPromise);

    } catch (error) {
      console.error("Error on getting company: ", error);
    }
  }

  useEffect(() => {
    doGetMyCompany();
  }, []);

  useEffect(() => {
    if(company){
      if(localStorage.getItem(company["data"]["company_logo_id"]) === null){
        getPhotoSource(company["data"]["company_logo_id"], token)
        .then(response => {
          const reader = response.body.getReader();
          readStream(reader)
          .then(base64Response => {
            localStorage.setItem(company["data"]["company_logo_id"], base64Response)
            setNrPhotosDownloaded(nr => nr+1)
          })
          
        })
      }
    }

  }, [company]);


  useEffect(() => {
    setMyStorage(localStorage)
  }, [nrPhotosDownloaded])


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      {company && 
      <Header title={company["data"]["company_name"]} subtitle={company["data"]["company_registration_number"]} photoSource={'data:image/png;base64,' + myStorage[company["data"]["company_logo_id"]]}>
        <MDBox mt={5} mb={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={12} xl={12} sx={{ display: "flex" }}>
              
                <ProfileInfoCard
                  title="Address"
                  description={company["data"]["company_address"]}
                  info={{
                    city: company["data"]["company_city"],
                    location: company["data"]["company_country"],
                    email: company["data"]["company_email"],
                    website: company["data"]["company_website"],
                    taxId: company["data"]["company_tax_id"]
                  }}
                  action={{ route: "", tooltip: "Edit Profile" }}
                  shadow={false}
                />
             
            </Grid>
          </Grid>
        </MDBox>
      </Header>
       }
      <Footer />
    </DashboardLayout>
  );
}

export default RetailerProfile;
